import { Link } from "react-router-dom";

export default function ProductCard({ product }) {
  const isInquiryOnly = product.inquiry_only === true;

  return (
    <Link 
      to={`/collection/${product.id}`}
      className="product-card bg-[#161616] border border-[#b8966a]/10 group block"
      data-testid={`product-card-${product.id}`}
    >
      {/* Image */}
      <div className="image-zoom aspect-[3/4] overflow-hidden relative">
        <img
          src={product.image_url}
          alt={product.name}
          className="w-full h-full object-cover"
        />
        {isInquiryOnly && (
          <div className="absolute top-3 right-3 bg-[#0c0c0c]/80 backdrop-blur-sm px-3 py-1 border border-[#b8966a]/30">
            <p className="font-sans text-[9px] tracking-[0.15em] uppercase text-[#b8966a]">Inquiry Only</p>
          </div>
        )}
      </div>

      {/* Content */}
      <div className="p-6">
        <p className="overline mb-2">{product.category === "bouquet" ? "Bouquet" : product.category === "arrangement" ? "Arrangement" : product.category}</p>
        <h3 className="font-heading text-xl text-[#f8f5f0] mb-2 group-hover:text-[#b8966a] transition-colors">
          {product.name}
        </h3>
        <p className="font-body text-sm text-[#a19d98] line-clamp-2 mb-4">
          {product.description}
        </p>
        <p className="font-sans text-sm text-[#b8966a]">
          {isInquiryOnly ? `Starting at $${product.price.toFixed(2)}` : `$${product.price.toFixed(2)}`}
        </p>
      </div>
    </Link>
  );
}
